import { CarnivoreUser } from '../_types/user.type'

// The Carnivore 33 is Direct Axxess content: every DA member sees it, nobody
// else does. This was briefly behind a per-user `carnivore100` rollout flag on
// top of the tier check; that flag is gone and the tier is the whole gate. The
// backend enforces the same single check (verifyAxxess on the carnivore-100
// route). Kept as a named helper so the three call sites read as intent and
// there is one place to re-gate if the list is ever staged again.
export function hasCarnivore100(user: CarnivoreUser | null | undefined): boolean {
  return !!user?.isAxxess
}

// Position size calculator in the top bar. Per-user rollout only — the flag is
// set by hand in Mongo (user.featureFlags) and rides along on GET /user. There
// is no backend gate to match: the modal's only call is /stock/info, which the
// stock page, ticker drawer and heater cards already hit for every user, so
// hiding the button is the whole feature gate.
export function hasCalculator(user: CarnivoreUser | null | undefined): boolean {
  return !!user?.featureFlags?.includes('calculator')
}
